<template>
  <table class="table table-hover table-sm m-1">
    <thead>
      <tr>
        <th class="col-2">이름</th>
        <th class="col-1">착용 레벨</th>
        <th class="col-2">대상 아이템</th>
        <th class="col">룬 순서</th>
        <th class="col-3">option</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="runeword in runewordList"
        :key="runeword.nameKo"
        :class="isRunewordDisplay(runeword) ? '' : 'd-none'"
      >
        <td>{{ runeword.nameKo }} ({{ runeword.name }})</td>
        <td v-text="runeword.reqLv > 0 ? runeword.reqLv : '-'"></td>
        <td>
          <ul class="list-group list-group-flush">
            <li
              class="list-group-item"
              v-for="itemCategory in runeword.itemCategoryList"
              :key="itemCategory"
            >
              ({{ runeword.runeList.length }})
              {{ getItemCategory(itemCategory).nameKo }}
            </li>
          </ul>
        </td>
        <td>
          <RuneButton
            v-for="rune in runeword.runeList"
            :key="rune"
            :id="getRune(rune).id"
          />
        </td>
        <td
          v-html="runeword.completeStats.replace(/(?:\r\n|\r|\n)/g, '<br />')"
        ></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import RuneButton from "@/components/diablo2/RuneButton.vue";

export default {
  components: { RuneButton },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      runeList: (state) => state.diablo2.rune.runeList,
      runewordList: (state) => state.diablo2.runeword.runewordList,
      itemCategoryList: (state) => state.diablo2.itemCategory.itemCategoryList,

      selectedRuneIdList: (state) =>
        state.diablo2.runewordSearch.selectedRuneIdList,
      selectedItemCategoryNameList: (state) =>
        state.diablo2.runewordSearch.selectedItemCategoryNameList,
      selectedSocketCountList: (state) =>
        state.diablo2.runewordSearch.selectedSocketCountList,
      selectedRecommandList: (state) =>
        state.diablo2.runewordSearch.selectedRecommandList,
      searchKeyword: (state) => state.diablo2.runewordSearch.searchKeyword,
    }),
    ...mapGetters("diablo2/itemCategory", ["getItemCategoryByName"]),
  },
  methods: {
    getRune(id) {
      var targetRune = null;
      for (var i = 0; i < this.runeList.length; i++) {
        if (this.runeList[i].id == id) {
          targetRune = this.runeList[i];
          break;
        }
      }
      return targetRune;
    },
    getItemCategory(itemCategoryName) {
      var targetItemCategory = null;
      for (var i = 0; i < this.itemCategoryList.length; i++) {
        if (this.itemCategoryList[i].name == itemCategoryName) {
          targetItemCategory = this.itemCategoryList[i];
          break;
        }
      }
      return targetItemCategory;
    },
    isRunewordDisplay(runeword) {
      // 여기서 보여줄지 말지 결정, 여러 조건에 부합하는 경우를 결정해야함.
      // 1. 선택한 룬
      // 2. 선택한 아이템
      // 3. 검색어
      var isDisplay = true;

      //선택한 룬에 해당되는 룬워드 검색. and 조건
      if (
        this.selectedRuneIdList !== undefined &&
        this.selectedRuneIdList.length > 0
      ) {
        isDisplay = true;

        this.selectedRuneIdList.forEach((selectedRuneId) => {
          var isTargetRuneInclude = false;
          runeword.runeList.forEach((rune) => {
            if (selectedRuneId == rune) {
              isTargetRuneInclude = true;
            }
          });
          if (!isTargetRuneInclude) {
            isDisplay = false;
          }
        });
      }

      // selectedRuneIdList 대상이 아닌 경우 비노출 처리
      if (!isDisplay) {
        return isDisplay;
      }

      // itemCategory에 해당하는 룬워드 검색. or 조건
      if (
        this.selectedItemCategoryNameList !== undefined &&
        this.selectedItemCategoryNameList.length > 0
      ) {
        isDisplay = false;
        this.selectedItemCategoryNameList.forEach(
          (selectedItemCategoryName) => {
            // 선택한 카테고리의 서브 카테고리까지 검색 대상
            var selectedItemCategoryNameHierarchyList = [];
            selectedItemCategoryNameHierarchyList.push(
              selectedItemCategoryName
            );
            this.getItemCategoryNameHierarchyList(
              selectedItemCategoryName,
              selectedItemCategoryNameHierarchyList
            );
            // 해당하는 카테고리에 해당하는 아이템인지 확인
            selectedItemCategoryNameHierarchyList.forEach(
              (selectedItemCategoryHierarchy) => {
                runeword.itemCategoryList.forEach((itemCategoryName) => {
                  var targetItemCategoryNameHierarchyList = [];
                  targetItemCategoryNameHierarchyList.push(itemCategoryName);
                  this.getItemCategoryNameHierarchyList(
                    itemCategoryName,
                    targetItemCategoryNameHierarchyList
                  );

                  targetItemCategoryNameHierarchyList.forEach(
                    (targetItemCategoryName) => {
                      if (
                        selectedItemCategoryHierarchy ==
                          targetItemCategoryName &&
                        runeword.runeList.length <=
                          this.getItemCategoryByName(targetItemCategoryName)
                            .maxSocketCount
                      ) {
                        isDisplay = true;
                      }
                    }
                  );
                });
              }
            );
          }
        );
      }

      // selectedRuneIdList 대상이 아닌 경우 비노출 처리
      if (!isDisplay) {
        return isDisplay;
      }

      // socketCount 에 해당하는 룬워드 검색. or 조건
      if (
        this.selectedSocketCountList !== undefined &&
        this.selectedSocketCountList.length > 0
      ) {
        isDisplay = false;
        this.selectedSocketCountList.forEach((socketCount) => {
          if (runeword.runeList.length == socketCount) {
            isDisplay = true;
          }
        });
      }

      if (!isDisplay) {
        return isDisplay;
      }

      // recommand에 해당하는 룬워드 검색. or 조건
      if (
        this.selectedRecommandList !== undefined &&
        this.selectedRecommandList.length > 0
      ) {
        isDisplay = false;
        this.selectedRecommandList.forEach((recommand) => {
          if (runeword.recommand.indexOf(recommand) >= 0) {
            isDisplay = true;
          }
        });
      }

      if (!isDisplay) {
        return isDisplay;
      }

      // 검색어에 해당하는 runeword인지 확인
      if (this.searchKeyword !== undefined && this.searchKeyword !== "") {
        isDisplay = false;
        this.searchKeyword.split(",").forEach((keyword) => {
          if (
            keyword.length > 0 &&
            (runeword.nameKo.indexOf(keyword) >= 0 ||
              runeword.name.indexOf(keyword) >= 0 ||
              runeword.completeStats.indexOf(keyword) >= 0)
          ) {
            isDisplay = true;
          }
        });
      }

      return isDisplay;
    },
    getItemCategoryNameHierarchyList(
      itemCategoryParentName,
      targetItemCategoryNameHierarchyList
    ) {
      // 해당 itemCategory의 하위 itemCategory를 찾아야함. 즉 parentItemCategory가 itemCategory인 아이템 모두 찾아서 추가
      this.itemCategoryList.forEach((itemCategory) => {
        if (
          itemCategory.parentName == itemCategoryParentName &&
          targetItemCategoryNameHierarchyList.indexOf(itemCategory.name) < 0
        ) {
          targetItemCategoryNameHierarchyList.push(itemCategory.name);
          this.getItemCategoryNameHierarchyList(
            itemCategory.name,
            targetItemCategoryNameHierarchyList
          );
        }
      });
    },
  },
};
</script>

<style></style>
